(function () {
  if (window.vellutoFilterGroupsLoaded) return;
  window.vellutoFilterGroupsLoaded = true;
  window.vellutoColorGroupsLoaded = true;

  var groupsByLink = new WeakMap();
  var scheduled = false;

  var officialBrands = {
    'a x armani exchange': 'Armani Exchange',
    'antony morato': 'Antony Morato',
    'armani exchange': 'Armani Exchange',
    'boss': 'BOSS',
    'boxeur des rues': 'Boxeur des Rues',
    'calvin klein': 'Calvin Klein',
    'calvin klein jeans': 'Calvin Klein Jeans',
    'calvin klein underwear': 'Calvin Klein Underwear',
    'cavalli class': 'Cavalli Class',
    'dilectus': 'Dilectus',
    'dkny': 'DKNY',
    'ea7': 'EA7',
    'ea7 emporio armani': 'EA7',
    'emporio armani': 'Emporio Armani',
    'exe': 'EXÉ',
    'gcds': 'GCDS',
    'geox': 'Geox',
    'guess': 'Guess',
    'guess jeans': 'Guess Jeans',
    'hugo': 'HUGO',
    'hugo boss': 'Hugo Boss',
    'k way': 'K-Way',
    'karl lagerfeld': 'Karl Lagerfeld',
    'lacoste': 'Lacoste',
    'levis': "Levi's",
    'liu jo': 'Liu Jo',
    'liu jo sport': 'Liu Jo Sport',
    'love moschino': 'Love Moschino',
    'marciano by guess': 'Marciano by Guess',
    'napapijri': 'Napapijri',
    'north sails': 'North Sails',
    'northsails': 'North Sails',
    'norway 1963': 'Norway 1963',
    'o neill': "O'Neill",
    'philipp plein': 'Philipp Plein',
    'pinko': 'Pinko',
    'polo ralph lauren': 'Polo Ralph Lauren',
    'ralph lauren': 'Ralph Lauren',
    'relish': 'Relish',
    'roberto cavalli': 'Roberto Cavalli',
    'the north face': 'The North Face',
    'timberland': 'Timberland',
    'tommy hilfiger': 'Tommy Hilfiger',
    'tommy jeans': 'Tommy Jeans',
    'troppo': 'Troppo',
    'u s polo assn': 'U.S. Polo Assn.',
    'us polo assn': 'U.S. Polo Assn.',
    'vans': 'Vans',
    'versace': 'Versace',
    'versace jeans': 'Versace Jeans',
    'versace jeans couture': 'Versace Jeans Couture'
  };

  function stripCount(text) {
    return String(text || '').replace(/\(\s*\d+\s*\)\s*$/, '').trim();
  }

  function normalizeLabel(text) {
    return stripCount(text).toLocaleLowerCase('pt-PT');
  }

  function normalizeBrandKey(text) {
    var key = stripCount(text)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase('pt-PT')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (key === 'u s polo association' || key === 'us polo association') return 'u s polo assn';
    if (key === 'a x') return 'a x armani exchange';
    return key;
  }

  function titleCaseBrand(key) {
    var lowerWords = ['and', 'by', 'da', 'de', 'des', 'do', 'dos', 'of'];
    return key.split(' ').map(function (word, index) {
      if (index > 0 && lowerWords.indexOf(word) !== -1) return word;
      return word.charAt(0).toLocaleUpperCase('pt-PT') + word.slice(1);
    }).join(' ');
  }

  function brandDisplayName(key) {
    return officialBrands[key] || titleCaseBrand(key);
  }

  function isColorFilter(title) {
    return ['cor', 'color', 'colors', 'colour', 'colours', 'colore', 'colori', 'couleur', 'couleurs'].indexOf(normalizeLabel(title)) !== -1;
  }

  function isBrandFilter(title) {
    return ['marca', 'marcas', 'brand', 'brands', 'vendor', 'fabricante'].indexOf(normalizeLabel(title)) !== -1;
  }

  function filterTypeFromTitle(title) {
    if (isColorFilter(title)) return 'color';
    if (isBrandFilter(title)) return 'brand';
    return '';
  }

  function pairIsColor(pair) {
    return /(?:color|colour|colore|couleur|cor)/i.test(pair.name);
  }

  function pairIsBrand(pair) {
    return /(?:^|\.)(?:vendor|brand|marca|fabricante)(?:\.|$)/i.test(pair.name);
  }

  function originalLinkLabel(link) {
    if (link.hasAttribute('data-velluto-original-label')) {
      return link.getAttribute('data-velluto-original-label');
    }

    var countNode = link.querySelector('.t4s-value-count');
    var label = link.textContent;
    if (countNode) label = label.replace(countNode.textContent, '');
    label = stripCount(label);
    link.setAttribute('data-velluto-original-label', label);
    return label;
  }

  function setLinkLabel(link, label) {
    var countNode = link.querySelector('.t4s-value-count');
    var textNodes = Array.prototype.filter.call(link.childNodes, function (node) {
      return node.nodeType === 3 && node.textContent.trim() !== '';
    });

    if (textNodes.length > 0) {
      textNodes[0].textContent = label;
      textNodes.slice(1).forEach(function (node) {
        node.textContent = '';
      });
    } else {
      link.insertBefore(document.createTextNode(label), countNode || null);
    }

    link.setAttribute('data-velluto-display-label', label);
  }

  function countValues(values) {
    var counts = new Map();
    values.forEach(function (value) {
      counts.set(value, (counts.get(value) || 0) + 1);
    });
    return counts;
  }

  function diffPairs(fromUrl, toUrl) {
    var pairs = [];
    var names = new Set();

    toUrl.searchParams.forEach(function (_value, name) {
      if (name.indexOf('filter.') === 0) names.add(name);
    });

    names.forEach(function (name) {
      var fromCounts = countValues(fromUrl.searchParams.getAll(name));
      var toCounts = countValues(toUrl.searchParams.getAll(name));

      toCounts.forEach(function (amount, value) {
        var missing = amount - (fromCounts.get(value) || 0);
        for (var index = 0; index < missing; index += 1) {
          pairs.push({ name: name, value: value });
        }
      });
    });

    return pairs;
  }

  function uniquePairs(pairs) {
    var seen = new Set();
    return pairs.filter(function (pair) {
      var key = pair.name + '\u0000' + pair.value;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function removePairs(url, pairs) {
    var grouped = new Map();

    pairs.forEach(function (pair) {
      if (!grouped.has(pair.name)) grouped.set(pair.name, new Set());
      grouped.get(pair.name).add(pair.value);
    });

    grouped.forEach(function (values, name) {
      var keep = url.searchParams.getAll(name).filter(function (value) {
        return !values.has(value);
      });
      url.searchParams.delete(name);
      keep.forEach(function (value) {
        url.searchParams.append(name, value);
      });
    });
  }

  function addPairs(url, pairs) {
    pairs.forEach(function (pair) {
      if (url.searchParams.getAll(pair.name).indexOf(pair.value) === -1) {
        url.searchParams.append(pair.name, pair.value);
      }
    });
  }

  function processFacet(facet) {
    var title = facet.querySelector('.t4s-facet-title');
    if (!title) return;

    var filterType = filterTypeFromTitle(title.textContent);
    if (!filterType) return;

    var labelGroups = new Map();

    facet.querySelectorAll('li').forEach(function (row) {
      var link = row.querySelector('a');
      if (!link) return;

      var originalLabel = originalLinkLabel(link);
      var key = filterType === 'brand' ? normalizeBrandKey(originalLabel) : normalizeLabel(originalLabel);
      if (!key) return;

      if (filterType === 'brand') {
        setLinkLabel(link, brandDisplayName(key));
      }

      var countNode = link.querySelector('.t4s-value-count');
      if (!row.hasAttribute('data-velluto-original-count')) {
        var parsedCount = countNode ? parseInt(countNode.textContent.replace(/\D/g, ''), 10) : 0;
        row.setAttribute('data-velluto-original-count', String(Number.isNaN(parsedCount) ? 0 : parsedCount));
      }

      if (!row.hasAttribute('data-velluto-original-selected')) {
        row.setAttribute('data-velluto-original-selected', row.classList.contains('is--selected') ? '1' : '0');
      }

      var groupKey = filterType + '\u0000' + key;
      if (!labelGroups.has(groupKey)) labelGroups.set(groupKey, []);
      labelGroups.get(groupKey).push({
        row: row,
        link: link,
        selected: row.getAttribute('data-velluto-original-selected') === '1',
        filterType: filterType
      });
    });

    labelGroups.forEach(function (items) {
      items.forEach(function (item) {
        item.row.hidden = false;
      });

      if (items.length < 2) return;

      var first = items[0];
      var total = items.reduce(function (sum, item) {
        return sum + Number(item.row.getAttribute('data-velluto-original-count') || 0);
      }, 0);
      var selected = items.some(function (item) { return item.selected; });
      var countNode = first.link.querySelector('.t4s-value-count');
      var nextCount = '(' + total + ')';

      first.row.classList.toggle('is--selected', selected);
      first.link.setAttribute('data-velluto-filter-group', first.filterType);

      if (countNode && countNode.textContent !== nextCount) {
        countNode.textContent = nextCount;
      }

      items.slice(1).forEach(function (item) {
        item.row.hidden = true;
      });

      groupsByLink.set(first.link, items);
    });
  }

  function processActiveFilters(root) {
    var current = new URL(window.location.href);
    var labelGroups = new Map();

    root.querySelectorAll('.t4s-active-filters__remove-filter').forEach(function (link) {
      var target = new URL(link.href, current);
      var removedPairs = diffPairs(target, current);
      var filterType = removedPairs.some(pairIsBrand) ? 'brand' : (removedPairs.some(pairIsColor) ? 'color' : '');
      if (!filterType) return;

      var originalLabel = originalLinkLabel(link);
      var key = filterType === 'brand' ? normalizeBrandKey(originalLabel) : normalizeLabel(originalLabel);
      if (!key) return;

      if (filterType === 'brand') {
        setLinkLabel(link, brandDisplayName(key));
      }

      var groupKey = filterType + '\u0000' + key;
      if (!labelGroups.has(groupKey)) labelGroups.set(groupKey, []);
      labelGroups.get(groupKey).push({ link: link, selected: true, filterType: filterType });
    });

    labelGroups.forEach(function (items) {
      items.forEach(function (item) {
        item.link.hidden = false;
      });

      if (items.length < 2) return;

      var first = items[0];
      first.link.setAttribute('data-velluto-filter-group', first.filterType);
      items.slice(1).forEach(function (item) {
        item.link.hidden = true;
      });
      groupsByLink.set(first.link, items);
    });
  }

  function processAll() {
    document.querySelectorAll('.t4s-facet').forEach(processFacet);
    processActiveFilters(document);
  }

  function scheduleProcess() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      processAll();
    }, 0);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[data-velluto-filter-group]');
    if (!link) return;

    var items = groupsByLink.get(link);
    if (!items || items.length < 2) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var current = new URL(window.location.href);
    var pairs = [];

    items.forEach(function (item) {
      var target = new URL(item.link.href, current);
      var itemPairs = item.selected ? diffPairs(target, current) : diffPairs(current, target);
      pairs = pairs.concat(itemPairs);
    });

    pairs = uniquePairs(pairs);

    if (pairs.length === 0) {
      window.location.assign(link.href);
      return;
    }

    if (items.some(function (item) { return item.selected; })) {
      removePairs(current, pairs);
    } else {
      addPairs(current, pairs);
    }

    current.searchParams.delete('page');
    window.location.assign(current.toString());
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll, { once: true });
  } else {
    processAll();
  }

  new MutationObserver(scheduleProcess).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}());
